// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientDemographics {
    static getAttributeTypeMap() {
        return PatientDemographics.attributeTypeMap;
    }
}
PatientDemographics.discriminator = undefined;
PatientDemographics.additionalProperties = false;
PatientDemographics.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "race",
        "baseName": "race",
        "type": "Race"
    },
    {
        "name": "ethnicity",
        "baseName": "ethnicity",
        "type": "Ethnicity"
    },
    {
        "name": "ssn",
        "baseName": "ssn",
        "type": "string"
    },
    {
        "name": "emailAddress",
        "baseName": "emailAddress",
        "type": "string"
    },
    {
        "name": "homePhone",
        "baseName": "homePhone",
        "type": "string"
    },
    {
        "name": "homeVoicemail",
        "baseName": "homeVoicemail",
        "type": "boolean"
    },
    {
        "name": "cellPhone",
        "baseName": "cellPhone",
        "type": "string"
    },
    {
        "name": "cellVoicemail",
        "baseName": "cellVoicemail",
        "type": "boolean"
    },
    {
        "name": "workPhone",
        "baseName": "workPhone",
        "type": "string"
    },
    {
        "name": "workPhoneExtension",
        "baseName": "workPhoneExtension",
        "type": "string"
    },
    {
        "name": "workVoicemail",
        "baseName": "workVoicemail",
        "type": "boolean"
    },
    {
        "name": "emailOptIn",
        "baseName": "emailOptIn",
        "type": "boolean"
    },
    {
        "name": "emailPreferred",
        "baseName": "emailPreferred",
        "type": "boolean"
    },
    {
        "name": "mailOptIn",
        "baseName": "mailOptIn",
        "type": "boolean"
    },
    {
        "name": "mailPreferred",
        "baseName": "mailPreferred",
        "type": "boolean"
    },
    {
        "name": "phoneOptIn",
        "baseName": "phoneOptIn",
        "type": "boolean"
    },
    {
        "name": "phonePreferred",
        "baseName": "phonePreferred",
        "type": "boolean"
    },
    {
        "name": "textOptIn",
        "baseName": "textOptIn",
        "type": "boolean"
    },
    {
        "name": "textPreferred",
        "baseName": "textPreferred",
        "type": "boolean"
    },
    {
        "name": "contact",
        "baseName": "contact",
        "type": "Contact"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "Address"
    },
    {
        "name": "thirdPartyId",
        "baseName": "thirdPartyId",
        "type": "string"
    },
    {
        "name": "pharmacyMemberNumber",
        "baseName": "pharmacyMemberNumber",
        "type": "string"
    },
    {
        "name": "medicalMemberNumber",
        "baseName": "medicalMemberNumber",
        "type": "string"
    },
];
//# sourceMappingURL=patientDemographics.js.map